@if (config$ | async; as config) {
    <sh-embedded-search-page [config]="config" (columnSelectionChanged)="onColumnSelectionChanged($event)">
        <ng-content aboveSearchBar select="[aboveSearchBar]"></ng-content>

        @if (config$ | async; as config) {
            <sh-profile-facet-list
                filtersContent
                [facetProfile]="facetProfile$ | async"
                [queryRestrictions]="queryRestrictions"
                [facetRefreshTriggers]="config.search.refreshTriggers"
            > </sh-profile-facet-list>
        }

        @if ($pimFeatureEnabled()) {
            <sh-record-tree-panel hierarchyContent></sh-record-tree-panel>
        }

        <ng-content abovePageHeader select="[abovePageHeader]"></ng-content>

        <ng-content belowPageHeader select="[belowPageHeader]"></ng-content>

        <ng-content detailContent select="[detailContent]"></ng-content>
    </sh-embedded-search-page>

    <router-outlet name="preview"></router-outlet>
}
